export default __webpack_public_path__ + "static/media/regular.8b5fb108.ttf";